import Reflux from 'reflux';

export default Reflux.createActions({
    "throwError": {sync:true},
    "checkForErrors": {asyncResult: true}
});


/** WEBPACK FOOTER **
 ** ./app-react/reflux/ErrorHandlerActions.js
 **/